import { useCallback, useEffect, useRef, useState } from 'react';
import Layout from '../../data/Layout';
import { Button, Col, Form, Row } from 'react-bootstrap';
import ReactSelect from '../../data/reactSelect';
import LayoutTable from '../../data/LayoutTable';
import DataTable from 'react-data-table-component';
import Globals from '../../../Globals.json';
import { notify } from '../../notify/notify-component';
import tableStyleDefault from '../../../Services/tableStyleDefault';
import { InputDefault } from '../../data/inputDefault';
import CustomLoader from '../../data/customLoader';
import { useAppSelector } from '../../../redux/store';
import * as S from './styled';
import { getProductsWithFiltersAsync } from '../../../redux/features/product/services';
import { useQueryFetchPages } from '../../../apiQuery/useQueryFetchPages';
import LayoutNotFilter from '../../data/LayoutNotFilter';
import { useUpdateData } from '../../../apiQuery/useUpdateData';
import { paginationOptions } from '../../data/PagineteInfo';
import FormControlDecimal from '../../data/formControlDecimal';

export default function TabelaPreco() {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const { mutate: updateProduct } = useUpdateData(['products']);
  const {
    data: categories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQueryFetchPages<any>(
    ['categories'],
    `${Globals.api.categoriesCompleted}`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  const [page, setPage] = useState(1);

  const [name, setName] = useState<string>();
  const [categoriaSelecionada, setCategoriaSelecionada] = useState('');
  const {
    data: productResponseData,
    isLoading,
    isError,
  } = useQueryFetchPages(['products'], `${Globals.api.products}`, {
    page: page,
    // A lista vira estado editável (preços pendentes); atualizar apagaria a edição.
    refetchInterval: false,
    queryParams: {
      //append: 'stock_qty',
      store_id: storeMe?.storeActive?.id,

      ...(name &&
        name.trim().length > 2 && {
        'filter[product_name]': name.trim(),
      }),
      ...(categoriaSelecionada && {
        'filter[id_pdv_category]': categoriaSelecionada,
      }),
    },
  });
  const refInputs = useRef<Array<any>>([]);
  const [option, setOption] = useState('sell');
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearRows, setClearRows] = useState<boolean>(false);
  const [perPage, setPerPage] = useState<number>(0);
  const [current_id_row, setCurrent_id_row] = useState<number>(0);
  const [venda, setVenda] = useState('');
  const [custo, setCusto] = useState('');
  const [markupPrice, setMarkupPrice] = useState('');
  const [markupPercentil, setMarkupPercentil] = useState('');
  const [sellDisabled, setSellDisabled] = useState<boolean>(true);
  const [markupPriceDisabled, setMarkupPriceDisabled] = useState<boolean>(true);
  const [markupPercentDisabled, setMarkupPercentDisabled] =
    useState<boolean>(true);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [productResponse, setProductsResponse] = useState<any>();
  const [pendingChanges, setPendingChanges] = useState<Record<number, any>>({});

  const handlePreco = (e: any, row: any) => {
    let preco = e.target.value;
    setCurrent_id_row(row.id);

    if (preco === undefined || preco.toString() === 'NaN') {
      preco = 0;
    }

    if (!productResponse || !Array.isArray(productResponse.data)) {
      return;
    }

    const updatedRow = { ...row, sale_price: preco };

    const updatedProducts = productResponse.data.map((x: any) =>
      x.id === row.id ? updatedRow : x
    );

    setProductsResponse({ ...productResponse, data: updatedProducts });
    setPendingChanges((prev) => ({ ...prev, [row.id]: updatedRow }));
  };

  const handleOnKeyPress = (e: any, _row: any) => {
    const id = parseInt(e.target.id);
    if (id < perPage) {
      refInputs.current[id].focus();
    }
    setCurrent_id_row(0);
  };

  const handleSavePendingChanges = () => {
    Object.values(pendingChanges).forEach((row: any) => {
      let updatedRow = { ...row };

      if ((updatedRow?.cost_price ?? 0) > 0) {
        updatedRow.sale_price = parseFloat(
          updatedRow.sale_price.toString().replace(',', '.')
        );

        if ((updatedRow?.markup_value ?? 0) !== 0) {
          updatedRow.markup_value = updatedRow.sale_price - updatedRow.cost_price;
        }

        if ((updatedRow?.markup_percentil ?? 0) !== 0) {
          const resto = updatedRow.sale_price - updatedRow.cost_price;
          updatedRow.markup_percentil = (
            (resto / updatedRow.cost_price) *
            100
          ).toFixed(2);
        }
      }

      AtualizarPrecoProd(updatedRow);
    });
    setPendingChanges({});
  };

  const addRefs = (el: any) => {
    if (el) {
      refInputs.current = refInputs.current.filter(
        (x) => parseInt(x.id) < parseInt(el.id)
      );
    }

    if (el && !refInputs.current.includes(el)) {
      refInputs.current.push(el);
    }
  };

  const handleInputPrice = (e: any) => {
    const valor = e.target.value.replace(/[^0-9,]+/g, '');
    setVenda(valor);
  };

  const handleInputMarkupPrice = (e: any) => {
    const valor = e.target.value.replace(/[^0-9,]+/g, '');
    setMarkupPrice(valor);
  };
  const handleInputMarkupPerc = (e: any) => {
    const valor = e.target.value.replace(/[^0-9,]+/g, '');
    setMarkupPercentil(valor);
  };

  const onBlurInputPrice = (e: any) => {
    const valor = e.target.value.replace(/[^0-9,]+/g, '');
    if (custo !== '' && markupPercentil !== '') {
      setVenda(
        (
          (parseFloat(custo.replace(/[^0-9,]+/g, '')) *
            parseFloat(markupPercentil.replace(/[^0-9,]+/g, ''))) /
          100 +
          parseFloat(custo.replace(/[^0-9,]+/g, ''))
        )
          .toFixed(2)
          .toString()
          .replace('.', ',')
      );
    } else if (custo !== '' && markupPrice !== '') {
      setVenda(
        (parseFloat(custo) + parseFloat(markupPrice))
          .toFixed(2)
          .toString()
          .replace('.', ',')
      );
    } else if (parseFloat(valor)) {
      setVenda(
        parseFloat(valor.replace(',', '.')).toFixed(2).replace('.', ',')
      );
    } else {
      setVenda('');
    }
  };

  const limparCamposMassa = () => {
    setMarkupPercentil('');
    setCusto('');
    setMarkupPrice('');
    setVenda('');

    getProductsWithFiltersAsync({ storeId: storeMe?.storeActive?.id, page });
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handleRowsChange = useCallback((state: any) => {
    setSelectedRows(state.selectedRows);
    setClearRows(false);

    if (state.selectedRows.length === 0) {
      limparCamposMassa();
    }
  }, []);

  const AtualizarMassa = () => {
    const price = parseFloat(venda !== '' ? venda.replace(',', '.') : '');
    const mPrice = parseFloat(
      markupPrice !== '' ? markupPrice.replace(',', '.') : ''
    );
    const mPerc = parseFloat(
      markupPercentil !== '' ? markupPercentil.replace(',', '.') : '0'
    );

    selectedRows.forEach((x: any, index) => {
      const data = {
        uuid: x.uuid,
        store_id: x.store_id,
        id_pdv_category: x.id_pdv_category,
        sale_price: price
          ? price
          : mPrice
            ? mPrice + x.sale_price
            : x.sale_price / (1 - mPerc / 100),
        cost_price: x.cost_price,
        markup_value: mPrice ? mPrice : 0,
        markup_percentil: mPerc ? mPerc : 0,
        sale_name: x.sale_name,
      };
      handleUpdateProdMassa(data);
    });
    notify('Produtos atualizados com sucesso!');
    limparCamposMassa();
  };

  const AtualizarStatusProd = (row: any, status: boolean) => {
    const data = {
      id_pdv_category: row?.id_pdv_category,
      uuid: row.uuid,
      store_id: row.store_id,
      is_active: status,
    };

    handleUpdateProd(data);

    const updatedProducts = productResponse?.data?.map((x: any) =>
      x.id === row.id ? { ...x, is_active: status } : x
    );

    setProductsResponse({ ...productResponse, data: updatedProducts });
  };

  const AtualizarPrecoProd = (row: any) => {
    const data = {
      uuid: row.uuid,
      store_id: row.store_id,
      sale_price: row.sale_price,
      id_pdv_category: row?.id_pdv_category,
      ...(row.markup_value && { markup_value: row.markup_value }),
      ...(row.markup_percentil && { markup_percentil: row.markup_percentil }),
    };

    handleUpdateProd(data);
  };

  const handleUpdateProd = (produto: any) => {
    updateProduct({
      endpoint: Globals.api.products,
      id: produto.uuid,
      payload: { ...produto },
    });
  };

  const handleUpdateProdMassa = (produto: any) => {
    updateProduct({
      endpoint: Globals.api.products,
      id: produto.uuid,
      payload: { ...produto },
    });
  };

  const columns = [
    {
      name: 'Código',
      center: true,
      grow: 0.2,
      sortable: true,
      selector: (row: any) => Number(row.id_pdv),
    },
    {
      name: 'Descrição',
      center: false,
      sortable: true,
      selector: (row: any) => row.sale_name.toLowerCase() ?? 0,
    },
    {
      name: 'Custo',
      center: true,
      grow: 0.3,
      sortable: true,
      selector: (row: any) =>
        row.cost_price.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      name: 'Preço',
      center: true,
      grow: 0.3,
      sortable: true,
      cell: (row: any, inp: any) => (
        <div>
          <FormControlDecimal
            className="fs-8"
            autoComplete="off"
            value={
              (current_id_row ?? 0) === row.id ? row.sale_price : row.sale_price
            }
            name="sale_price"
            maxLength={16}
            id={inp + 1}
            ref={addRefs}
            onChange={(e: any) => handlePreco(e, row)}
            //onKeyPress={(e: any) => handleOnKeyPress(e, row)}
            onBlur={(e: any) => handleOnKeyPress(e, row)}
          />
        </div>
      ),
    },
    {
      name: 'Markup R$',
      center: true,
      grow: 0.3,
      selector: (row: any) =>
        row.markup_value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      name: 'Markup %',
      center: true,
      grow: 0.3,
      selector: (row: any) => row.markup_percentil + ' %',
    },
    {
      name: 'Status',
      center: true,
      grow: 0.3,
      cell: (row: any) => (
        <div className="actions">
          <Form.Check
            className="check"
            type="switch"
            label={row.is_active ? 'Ativo' : 'Inativo'}
            checked={row.is_active ? true : false}
            placeholder={row.is_active ? 'Ativo' : 'Inativo'}
            onChange={(e: any) => AtualizarStatusProd(row, e.target.checked)}
          />
        </div>
      ),
      button: true,
    },
  ];

  function calcMarkup(markUp: number, priceSale: number, markupPrice: number) {
    const calc =
      ((priceSale + markupPrice) * markUp) / 100 + (priceSale + markupPrice);

    if (calc === Infinity || !calc) {
      return '';
    }
    return calc.toFixed(2);
  }

  function calcMarkupValue(priceSale: number, priceCost: number) {
    const calc = priceSale + priceCost;
    if (calc === Infinity || !calc) {
      return '';
    }
    return calc.toFixed(2);
  }

  const handleChangeMarkupPriceValues = () => {
    if (parseFloat(markupPrice) > 0) {
      setVenda(calcMarkupValue(parseFloat(markupPrice), parseFloat(custo)));
    }
  };

  const handleChangeMarkupValues = () => {
    if (parseFloat(markupPercentil) > 0) {
      setVenda(
        calcMarkup(
          parseFloat(markupPercentil),
          parseFloat(custo),
          parseFloat(markupPrice)
        )
      );
    }
  };

  const handleRadiu = (event: string) => {
    setOption(event);
    switch (event) {
      case 'sell':
        setVenda(venda);
        setMarkupPrice(markupPrice);
        setMarkupPrice(markupPrice);
        setMarkupPriceDisabled(true);
        setMarkupPercentDisabled(true);
        setSellDisabled(false);
        break;

      case 'markupPrice':
        setVenda(venda);
        setMarkupPrice(markupPrice);
        setMarkupPrice(markupPrice);
        setMarkupPriceDisabled(false);
        setMarkupPercentDisabled(true);
        setSellDisabled(true);
        break;

      case 'markupPercent':
        setVenda(venda);
        setMarkupPriceDisabled(true);
        setMarkupPercentDisabled(false);
        setSellDisabled(true);
        break;
      default:
        break;
    }
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    //setPerPage(newPerPage);
    setPage(page);
  };

  const handleRadiuPrice = (event: string) => {
    setOption(event);
    switch (event) {
      case 'price':
        setSellDisabled(false);
        setMarkupPercentDisabled(true);
        setMarkupPriceDisabled(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleChangeMarkupPriceValues();
  }, [markupPrice]);

  useEffect(() => {
    handleChangeMarkupValues();
  }, [markupPercentil]);

  useEffect(() => {
    setProductsResponse(productResponseData);
  }, [productResponseData]);

  return (
    <>
      <LayoutNotFilter title="Tabela de preços">
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <ReactSelect
                label="Categoria"
                placeholder="Categoria"
                state={categoriaSelecionada}
                options={categories?.data?.map((item: any) => ({
                  ...item,
                  value: item?.id_pdv_category,
                  label: item.name,
                  store_id: item.store_id,
                }))}
                setState={setCategoriaSelecionada}
                isLoading={isLoadingCategories}
                isClearable
              />

              <InputDefault
                label="Produto"
                placeholder="Produto"
                type="text"
                state={name}
                setState={setName}
              />
            </div>
          )}

          <div className="max-screen">
            <ReactSelect
              label="Categoria"
              state={categoriaSelecionada}
              options={categories?.data?.map((item: any) => ({
                ...item,
                value: item?.id_pdv_category,
                label: item.name,
                store_id: item.store_id,
              }))}
              setState={setCategoriaSelecionada}
              isClearable
              isLoading={isLoadingCategories}
            />

            <InputDefault
              label="Produto"
              placeholder="Produto"
              type="text"
              state={name}
              setState={setName}
            />
          </div>
        </S.Wrapper>
      </LayoutNotFilter>
      {productResponse && productResponse?.data?.length > 0 && (
        <Layout>
          <Form>
            <Row className="">
              <Row>
                <Col md="8">
                  <S.Wrapper>
                    <div className="max-screen">
                      <InputDefault
                        label="Venda (R$)"
                        type="text"
                        autoComplete="off"
                        state={venda}
                        placeholder="Informe o Preço"
                        maxLength={18}
                        onChenge={(e: any) => handleInputPrice(e)}
                        onBlur={(e: any) => onBlurInputPrice(e)}
                        disabled={sellDisabled}
                      />
                    </div>
                    <div className="min-screen">
                      <InputDefault
                        label="Venda (R$)"
                        type="text"
                        autoComplete="off"
                        state={venda}
                        placeholder="Informe o Preço"
                        maxLength={18}
                        onChenge={(e: any) => handleInputPrice(e)}
                        onBlur={(e: any) => onBlurInputPrice(e)}
                        disabled={sellDisabled}
                      />
                    </div>
                  </S.Wrapper>
                </Col>
                <Col md="4">
                  <label className=" mx-3">Atualizar preço em massa:</label>
                  {['radio'].map((type: any) => (
                    <div key={`inline-${type}`} className="mb-3 mx-3">
                      <Form.Check
                        inline
                        label="Preço de venda"
                        type={type}
                        id="price"
                        value={option}
                        checked={option === 'price'}
                        disabled={selectedRows.length ? false : true}
                        onChange={(e: any) => handleRadiuPrice('price')}
                      />
                    </div>
                  ))}
                </Col>
              </Row>

              <Col md="8">
                <S.Wrapper>
                  <div className="max-screen">
                    <InputDefault
                      label="Markup (R$)"
                      type="text"
                      autoComplete="off"
                      state={markupPrice}
                      placeholder="Informe o Markup (R$)"
                      maxLength={18}
                      onChenge={(e: any) => handleInputMarkupPrice(e)}
                      disabled={markupPriceDisabled}
                    />
                    <InputDefault
                      label="Markup (%)"
                      type="text"
                      autoComplete="off"
                      state={markupPercentil}
                      placeholder="Informe o Markup (%)"
                      maxLength={18}
                      onChenge={(e: any) => handleInputMarkupPerc(e)}
                      disabled={markupPercentDisabled}
                    />
                  </div>
                  <div className="min-screen">
                    <InputDefault
                      label="Markup (R$)"
                      type="text"
                      autoComplete="off"
                      state={markupPrice}
                      placeholder="Informe o Markup (R$)"
                      maxLength={18}
                      onChenge={(e: any) => handleInputMarkupPrice(e)}
                      disabled={markupPriceDisabled}
                    />
                    <InputDefault
                      label="Markup (%)"
                      type="text"
                      autoComplete="off"
                      state={markupPercentil}
                      placeholder="Informe o Markup (%)"
                      maxLength={18}
                      onChenge={(e: any) => handleInputMarkupPerc(e)}
                      disabled={markupPercentDisabled}
                    />
                  </div>
                </S.Wrapper>
              </Col>

              <Col md="3">
                <label className="mb-2">Cálcular por:</label>
                {['radio'].map((type: any) => (
                  <div key={`inline-${type}`} className="">
                    <Form.Check
                      inline
                      label="Markup (R$)"
                      name="group1"
                      type={type}
                      id="MarkupR"
                      value={option}
                      checked={option === 'markupPrice'}
                      disabled={selectedRows.length ? false : true}
                      onChange={(e: any) => handleRadiu('markupPrice')}
                    />
                    <Form.Check
                      inline
                      label="Markup (%)"
                      name="group1"
                      type={type}
                      id="MarkupP"
                      value={option}
                      checked={option === 'markupPercent'}
                      disabled={selectedRows.length ? false : true}
                      onChange={(e: any) => handleRadiu('markupPercent')}
                    />
                  </div>
                ))}
              </Col>

              <Col className="mt-4 ">
                <Button
                  variant="success"
                  size="sm"
                  disabled={selectedRows.length ? false : true}
                  onClick={AtualizarMassa}
                >
                  Atualizar
                </Button>
              </Col>
            </Row>
          </Form>
        </Layout>
      )}

      {Object.keys(pendingChanges).length > 0 && (
        <div
          style={{
            position: 'fixed',
            bottom: '32px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1050,
          }}
        >
          <Button
            variant="primary"
            onClick={handleSavePendingChanges}
            style={{
              padding: '10px 32px',
              fontSize: '15px',
              borderRadius: '50px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
            }}
          >
            Salvar preços ({Object.keys(pendingChanges).length})
          </Button>
        </div>
      )}

      <LayoutTable>
        <DataTable
          columns={columns}
          data={productResponse?.data ?? []}
          striped
          pagination
          paginationServer
          paginationTotalRows={productResponse?.meta?.total}
          paginationDefaultPage={1}
          paginationPerPage={15}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          onSelectedRowsChange={handleRowsChange}
          clearSelectedRows={clearRows}
          selectableRows
          customStyles={tableStyleDefault}
          paginationComponentOptions={paginationOptions}
          progressPending={isLoading}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>
    </>
  );
}